import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface PermissionsState {
  loaded: boolean;
  loading: boolean;
  permissions: string[];
}

const initialState: PermissionsState = {
  loaded: false,
  loading: true,
  permissions: [],
};

export const companyPermissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setCompanyPermissionsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCompanyPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload;
      state.loading = false;
    },
  },
});

export const { setCompanyPermissionsLoading, setCompanyPermissions } =
  companyPermissionsSlice.actions;

export default companyPermissionsSlice.reducer;
